import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum'
import { twMerge } from 'tailwind-merge'
import {
  CommentIcon,
  CommunityIcon,
  InfoIcon,
  LikeIcon,
  MentionIcon,
  WarningIcon,
} from '@systemeio/ui/icons'
import { NotificationBaseItemInterface } from '../types/notification-types'

export const ruleIconSizeClassName =
  'h-[20px] min-w-[20px] w-[20px] fill-fill-primary text-fill-primary group-hover:text-text-primary group-hover:fill-text-primary transition'

export const getNotificationIcon = (notification: NotificationBaseItemInterface) => {
  switch (notification.eventType) {
    case NotificationTypeEnum.CommentOnCommunityPost:
    case NotificationTypeEnum.CommentReplyOnComment:
    case NotificationTypeEnum.CommentOnCourseCreatedByMe:
      return <CommentIcon className={ruleIconSizeClassName} />
    case NotificationTypeEnum.MentionInCommentOnCommunityPost:
    case NotificationTypeEnum.MentionInCommunityPost:
      return <MentionIcon className={ruleIconSizeClassName} />
    case NotificationTypeEnum.CommunityNewPendingPost:
    case NotificationTypeEnum.CommunityPostIsPublished:
      return <CommunityIcon className={ruleIconSizeClassName} />
    case NotificationTypeEnum.CommunityPostIsLiked:
    case NotificationTypeEnum.CommentIsLiked:
      return <LikeIcon className={ruleIconSizeClassName} />
    case NotificationTypeEnum.WithdrawalMethodOfAffiliateIsNotSet:
    case NotificationTypeEnum.ProfileInformationOfAffiliateIsNotFilled:
    case NotificationTypeEnum.DomainAuthenticationsNotValid:
    case NotificationTypeEnum.AffiliatePayoutFailed:
      return <WarningIcon className={twMerge(ruleIconSizeClassName, 'fill-yellow')} />
    default:
      return <InfoIcon className={twMerge(ruleIconSizeClassName, 'fill-yellow')} />
  }
}
